import React, { FC, memo, useCallback } from 'react';
import Router from 'next/router';
import styled from 'styled-components';
import { Alert } from 'react-bootstrap';
import _get from 'lodash/get';

import { Block } from '@views/components/block';
import EmptyState from './components/empty-state';
import GiftList from './components/gift-list';
import ProductList from './components/product-list';
import BlockAction from './components/block-action';

import Spinner from '@views/components/spinner';
import Placeholder from './placeholder';
import { INTERNAL_ROUTES } from '@helpers/route';
import { useData } from './utils';

const SubTitle = styled(Alert)`
  font-size: 1rem;
  font-weight: bold;
  font-style: italic;
  margin-top: 1rem;
  margin-bottom: 2rem;
`;

const CartComponent: FC<any> = () => {
  const {
    cart,
    loading,
    quantity,
    disabled,
    totalText,
    closedPrice,
    closedDiscount,
    closedPriceText,
    discount,
    totalNotEnough,
    discountText,
    grandTotalText,
    gift,
  } = useData();
  const handleSubmit = useCallback(() => {
    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    dataLayer.push({
      event: 'checkout',
      actionField: { step: 1, option: 'checkout' },
      ecommerce: {
        checkout: {
          products: cart.map((item) => ({
            name: _get(item, 'name'),
            id: _get(item, 'id'),
            price: parseInt(_get(item, 'price', 0)),
            brand: '',
            category: '',
            variant: '',
            quantity: _get(item, 'quantity', 1),
          })),
        },
      },
    });

    Router.replace(INTERNAL_ROUTES.CHECKOUT);
  }, [cart]);

  if (loading) {
    return <Placeholder />;
  }

  if (quantity > 0) {
    return (
      <Block className="mb-4">
        <Block.Header>
          <Block.Title heading as="h3">
            Giỏ hàng <span>({quantity} sản phẩm)</span>
          </Block.Title>
        </Block.Header>

        {closedPrice > 0 && (
          <SubTitle variant="info">
            Hãy mua thêm {closedPriceText} đơn hàng của bạn sẽ được áp dụng
            chiết khấu {closedDiscount}%
          </SubTitle>
        )}

        <div className="mt-4">
          <Spinner spin={loading}>
            <ProductList data={cart} gift={gift} />
            <GiftList />

            <BlockAction
              totalNotEnough={totalNotEnough}
              quantity={quantity}
              totalText={totalText}
              discount={discount}
              discountText={discountText}
              grandTotalText={grandTotalText}
              disabled={disabled}
              onSubmit={handleSubmit}
            />
          </Spinner>
        </div>
      </Block>
    );
  }

  return (
    <Block className="mb-4">
      <Spinner spin={loading}>
        <EmptyState />
      </Spinner>
    </Block>
  );
};

const Cart = memo(CartComponent);
Cart.displayName = 'Cart';

export default Cart;
